import React, { useEffect, useMemo, useState } from "react";
import { getAdminClients } from "@/api";
import { fmtMxn, inputCls } from "./adminShared";
import { Search } from "lucide-react";

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    getAdminClients().then(setClients).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return clients;
    return clients.filter((c) => `${c.name} ${c.email} ${c.whatsapp}`.toLowerCase().includes(needle));
  }, [clients, q]);

  return (
    <div data-testid="admin-clients">
      <p className="eyebrow mb-2">Relación</p>
      <h1 className="font-serif-hc font-light text-3xl md:text-4xl text-[#F5F2EA]">Clientes</h1>

      <label className="relative block mt-7 max-w-sm">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A3A095]" />
        <input data-testid="clients-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cliente…" className={`${inputCls} pl-9`} />
      </label>

      <div className="mt-5 overflow-x-auto border border-[#1E2B25]">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="bg-[#0C1310] text-left">
              {["Cliente", "Contacto", "Reservas", "Total gastado", "Último tour"].map((h) => (
                <th key={h} className="p-4 eyebrow font-normal">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((c) => (
              <tr key={c.email} data-testid={`client-row-${c.email}`} className="border-t border-[#1E2B25]">
                <td className="p-4 text-[#F5F2EA]">{c.name}</td>
                <td className="p-4">
                  <a href={`mailto:${c.email}`} className="block text-[#139090] hover:underline">{c.email}</a>
                  <a href={`https://wa.me/${(c.whatsapp || "").replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="block text-[#25D366] hover:underline mt-0.5">{c.whatsapp}</a>
                </td>
                <td className="p-4 text-[#F5F2EA]">{c.bookings}</td>
                <td className="p-4 text-[#C4A661]">{fmtMxn(c.total_spent_mxn)}</td>
                <td className="p-4 text-[#A3A095]">{c.last_tour}</td>
              </tr>
            ))}
            {!filtered.length && (
              <tr><td colSpan={5} className="p-10 text-center text-[#A3A095]" data-testid="clients-empty">Sin clientes registrados.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
